// Initial state 
const state = {
    AdministrationModalType: null,
    IsChangedInPerformForm: null,
    SaveLogIsDisabled: false,
    LastDoseDateForActions: null,
    NewPRNDoseDefaultDate: null,
    HasLogData: false,
    ShowLogWithUndoPerform: false,
    IsLastDoseClicked:false,
    AdministrationCardSelected: null 
};

// Update Data "mutations"
const mutations = {
    setAdministrationModalType(state, value) {
        state.AdministrationModalType = value
    },
    setChangedInPerformForm(state, value) {
        state.IsChangedInPerformForm = value
    },
    setSaveLogIsDisabled(state, value) {
        state.SaveLogIsDisabled = value
    },
    setLastDoseDateForActions(state, value) {
        state.LastDoseDateForActions = value
    },
    setAdministrationCardSelected(state, value) {
        state.AdministrationCardSelected = value;
    },
    setNewPRNDoseDefaultDate(state, value) {
        state.NewPRNDoseDefaultDate = value;
    },
    setHasLogData(state, value) {
        state.HasLogData = value;
    },
    setShowLogWithUndoPerform(state, value) {
        state.ShowLogWithUndoPerform = value;
    },
    setIsLastDoseClicked(state, value) {
        state.IsLastDoseClicked = value;
    }
};
// Get data
const getters = {
    getAdministrationModalType: state => {
        return state.AdministrationModalType;
    },
    getChangedInPerformForm: state => {
        return state.IsChangedInPerformForm;
    },
    getSaveLogIsDisabled: state => {
        return state.SaveLogIsDisabled;
    },
    getLastDoseDateForActions: state => {
        return state.LastDoseDateForActions;
    },
    getNewPRNDoseDefaultDate: state => {
        return state.NewPRNDoseDefaultDate;
    },
    getHasLogData: state => {
        return state.HasLogData;
    },
    getShowLogWithUndoPerform: state => {
        return state.ShowLogWithUndoPerform;
    },
    getIsLastDoseClicked: state => {
        return state.IsLastDoseClicked;
    },
    getAdministrationCardSelected: state => {
        return state.AdministrationCardSelected;
    }
};

export default {
    mutations,
    state,
    getters
};